<div class="p-2 m-2">
    <router-outlet></router-outlet>
</div>
